export const dark = [0.08, 0.07, 0.06];
